module.exports = __webpack_public_path__ + "dist/assets/redesign/ui/components/intro/img/intro-screen-4@3x__04f9c54e733bdfde699f408b2f99f14e.png";